import React, { useState, useEffect, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';

import ProgressBar from '@atoms/ProgressBar/index';
import { H5 } from '@styled';
import { getProfileStrengthPercent, getProfileStrengthText } from '../../../helpers/profileStrength.helpers';
import useViewer from '@hooks/useViewer';

const blinker = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

const Blink = styled.span`
    animation: ${blinker} 1s linear infinite;
`;

const ProfileStrengthStatus = () => {
    const [viewerPercent, setViewerPercent] = useState(null);
    const [animatedPercent, setAnimatedPercent] = useState(0);
    const [strengthText, setStrengthText] = useState(null);

    const updateStatus = useCallback(newViewer => {
        if (!newViewer) return;
        const usersPercent = getProfileStrengthPercent(newViewer);
        setViewerPercent(usersPercent);
        setStrengthText(getProfileStrengthText(usersPercent));
    }, []);

    const { loading, viewer } = useViewer({
        onCompleted: () => {
            updateStatus(viewer);
        },
    });

    useEffect(() => {
        if (!viewer) return;
        updateStatus(viewer);
    }, [updateStatus, viewer]);

    if (viewerPercent && animatedPercent < viewerPercent) {
        setAnimatedPercent(animatedPercent + 10);
    }

    return (
        <div style={{ position: 'relative' }}>
            <H5 className="mb-1rem">Profile Strength: {loading ? <Blink>Calculating...</Blink> : strengthText}</H5>
            <ProgressBar percent={animatedPercent} />
        </div>
    );
};

export default ProfileStrengthStatus;
